import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { makeFormDataFile } from 'src/app/controls/functions/file-function';

@Injectable()
export class JobseekerRegistrationService {

  api_url = environment.SERVER_URL + 'icrweb/home/';
  url = environment.SERVER_URL + 'icr/';
  constructor(
    private http: HttpClient
  ) { }

  getResumeDetailsWithMaster(req) {
    return this.http.post(this.api_url + 'resumeDetailWithMasterData_v3_career_portal', req, {
      headers: {
        'header_type': '1'
      }
    })
  }
  addNewSkill(req) {
    return this.http.post(this.api_url + 'addNewSkill', req)
  }
  getMasters(params?) {
    if (!params) {
      try {
        let ip_details = getIP()
        params = {}
        params['ip'] = ip_details['ip'];
        params['sellerShortCode'] = environment.SHORTCODE;
      }
      catch (err) {

      }
    }
    else {
      params['sellerShortCode'] = environment.SHORTCODE;
    }
    return this.http.get(environment.SERVER_URL + 'icrweb/countryMaster', { params: params, headers: { header_type: '2' } })
  }
  saveRegistration(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_signup', request);
  }
  saveResume(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_save_resume', request);
  }
  getKeySkills(request) {
    return this.http.post(this.api_url + 'searchSkill', request, {
      headers: {
        header_type: '2'
      }
    })
  }
  applyForJob(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_apply_job', request)

  }

  getCDNPath(file_name, base64) {
    return new Observable(obs => {
      let f = makeFormDataFile({ fileName: file_name, content: base64 })
      let form_data = new FormData();
      form_data.append('attachment', f, f.name);
      this.http.post(environment.SERVER_URL + 'service_attachment', form_data, {
        headers: { header_type: '2' }
      }).subscribe(res => {
        if (res && res['data']) {
          obs.next([{
            fileName: res['data']['a_fn'],
            cdnPath: res['data']['a_url']
          }])
        }

      })
    })


  }
  getRequirementList(request) {
    return this.http.post(this.api_url + 'get_jobtitle_list', request, {
      headers: {
        header_type: '2'
      }
    });
  }
  applyReferralCode(request) {
    return this.http.post(this.api_url + 'referredby', request, {
      headers: {
        header_type: '1'
      }
    })
  }

  getTalBalance(request) {
    return this.http.post(this.api_url + 'get_wallet_data', request, {
      headers: {
        header_type: '2'
      }
    })

  }

  sendOTP(request) {
    return this.http.post(this.url + 'sendOtpWeb', request, {
      headers: {
        header_type: '1'
      }
    })
  }

  verifyOTP(request) {
    return this.http.post(this.url + 'verifyOtpWeb', request, {
      headers: {
        header_type: '1'
      }
    })
  }

  loadSkills(request, header_type) {
    return this.http.post(environment.SERVER_URL + 'icrweb/home/searchSkill', request, {
      headers: {
        header_type: header_type || '2'
      }
    })
  }
  getJobs(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_job_detail', request);
  }

  getUniversityList(request) {
    return this.http.post(this.api_url + 'searchUniversity', request, {
      headers: {
        header_type: '2'
      }
    });
  }
  getCollegeList(request) {
    return this.http.post(this.api_url + 'searchCollege', request, {
      headers: {
        header_type: '2'
      }
    });
  }
}
export function getIP() {
  let obj = JSON.parse(localStorage.getItem('getipobject'));
  if (obj) {
    return obj;
  }
  else {
    return {
      city
        :
        "Jaipur",
      country
        :
        "IN",
      hostname
        :
        "abts-north-dynamic-101.334.177.122.airtelbroadband.in",
      ip
        :
        "122.234.345.11",
      loc
        :
        "26.9196,75.8383",
      org
        :
        "AS24340 Bharti Airtel Ltd., Telemedia Services",
      postal
        :
        "302034",
      region
        :
        "Rajasthan",
      timezone
        :
        "Asia/Kolkata"
    }
  }
}
